// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3YBlf","divider-animate":"Divider_divider-animate__eHV1k","slideInFromLeft":"Divider_slideInFromLeft__Yo5IU"};